export type Flags = {
  v3PricingCore: boolean
  v3HoaDisplay: boolean
}

/**
 * Fail-closed baseline. Every read path falls back to this, so a store outage
 * serves v2 pricing rather than a 5xx.
 */
export const DEFAULT_FLAGS: Flags = {
  v3PricingCore: false,
  v3HoaDisplay: false,
}
